import Pusher from 'pusher-js';
import PusherBatchAuthorizer from 'pusher-js-auth';
import { API_MICROSERVICES_URL } from '../../config';
import VueEcho from './echo';
import { app } from '../../app';
import MobileDetect from 'mobile-detect';
import { vueCookie } from 'utils/vueCookie';
import { get_url_wss } from 'utils/getConfigUrls';
const detect = new MobileDetect(window.navigator.userAgent);
const platform = detect.os();

class Websocket {
    constructor() {
        this.accessToken = null;
        this.isWidget = false;
    }

    connect = (accessToken, isWidget = false) => {
        this.accessToken = accessToken;
        this.isWidget = isWidget;

        if (this.accessToken) {
            app.use(VueEcho, this.config);
        }
    };

    get config() {
        let options = {
            authorizer: PusherBatchAuthorizer,
            auth: {
                headers: {
                    Authorization: `Bearer ${window.localStorage.getItem('token')}`,
                },
            },
            authDelay: 200,
            broadcaster: 'pusher',
            encrypted: true,
            namespace: null,
            csrfToken: window.Config.csrfToken,
            authEndpoint: `${API_MICROSERVICES_URL}core/broadcasting/auth?connection=${window.Config.broadcastingConnection}`,
        };

        if (this.accessToken) {
            if (this.isWidget) {
                // https://salesmsg.atlassian.net/browse/SWR-10027
                if (platform === 'iOS' && !vueCookie.hasCookies()) {
                    options.auth = {
                        headers: {
                            Authorization: `Bearer ${this.accessToken}`,
                        },
                    };
                }
            } else {
                options.auth = {
                    headers: {
                        Authorization: `Bearer ${this.accessToken}`,
                    },
                };
            }
        }

        if (window.Config.broadcastingConnection === 'soketi') {
            options['key'] = window.Config.soketi.key;
            options['wsHost'] = get_url_wss(window.Config.soketi.host);
            options['wsPort'] = window.Config.soketi.port;
            options['wssPort'] = window.Config.soketi.port;
            options['forceTLS'] = false;
            options['disableStats'] = true;
            options['enabledTransports'] = ['ws', 'wss'];
            options['client'] = new Pusher(window.Config.soketi.key, options);
        } else {
            options['key'] = window.Config.pusher.key;
            options['cluster'] = window.Config.pusher.cluster;
        }

        return options;
    }
}

export const websocket = new Websocket();
